export default "__VITE_ASSET__30k5ZutO__"